import { Box } from "@mui/material";
import ChatGroupBubble from "./ChatGroupBubble";
import { Message } from "../models/Message";
import { useAppSelector } from "../hooks/hooks";

interface ChatGroupProps {}

const ChatGroup = (props: ChatGroupProps) => {
  const { messages } = useAppSelector((state) => state.messages);
  if (messages.length === 0) return null;

  // Group consecutive messages from the same sender
  const groupedMessages: Message[][] = [];
  let currentGroup: Message[] = [];
  let currentSender = messages[0].sender;
  let currentDirection = messages[0].direction;

  messages.forEach((message, index) => {
    const isSameSender =
      message.sender === currentSender &&
      message.direction === currentDirection;

    if (isSameSender) {
      currentGroup.push(message);
    } else {
      groupedMessages.push([...currentGroup]);
      currentGroup = [message];
      currentSender = message.sender;
      currentDirection = message.direction;
    }

    // Push the last group
    if (index === messages.length - 1) {
      groupedMessages.push([...currentGroup]);
    }
  });

  return (
    <Box sx={{ width: "100%" }}>
      {groupedMessages.map((group, groupIndex) => (
        <ChatGroupBubble
          key={group[0].id}
          messages={group}
          showSender={true}
          isFirstInGroup={
            groupIndex === 0 ||
            groupedMessages[groupIndex - 1][0].sender !== group[0].sender
          }
          isLastInGroup={
            groupIndex === groupedMessages.length - 1 ||
            groupedMessages[groupIndex + 1][0].sender !== group[0].sender
          }
        />
      ))}
    </Box>
  );
};

export default ChatGroup;
